import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { ADMIN } from "@/constants/testIds";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => { if (user) nav("/admin", { replace: true }); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Signed in");
      nav("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-shell min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <img src="/skyverra-logo.png" alt="" className="h-12" />
          <div>
            <div className="font-display font-bold text-white text-xl tracking-tight">Skyverra</div>
            <div className="overline text-[color:var(--sky-cyan)]">Admin console</div>
          </div>
        </div>

        <div className="admin-card p-8">
          <div className="flex items-center gap-2 text-[color:var(--sky-cyan)]">
            <Lock size={16} />
            <div className="overline text-[color:var(--sky-cyan)]">Restricted</div>
          </div>
          <h1 className="mt-3 font-display font-bold text-2xl text-white">Sign in to manage your site</h1>
          <p className="text-sm text-[color:var(--sky-admin-muted)] mt-1">Only authorized administrators can access this area.</p>

          <form onSubmit={submit} className="mt-8 grid gap-4">
            <div className="grid gap-1">
              <label className="text-xs uppercase tracking-widest text-[color:var(--sky-admin-muted)]">Email</label>
              <input required type="email" data-testid={ADMIN.loginEmail} className="admin-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="info@skyverraconsulting.in" />
            </div>
            <div className="grid gap-1">
              <label className="text-xs uppercase tracking-widest text-[color:var(--sky-admin-muted)]">Password</label>
              <input required type="password" data-testid={ADMIN.loginPassword} className="admin-input" value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <button disabled={loading} data-testid={ADMIN.loginSubmit} className="admin-btn mt-2 disabled:opacity-60">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>

        <p className="text-xs text-[color:var(--sky-admin-muted)] mt-6 text-center">Skyverra Consulting · Admin only</p>
      </div>
    </div>
  );
}
